export enum EventStatus {
    Active = 1,
    Upcoming = 2,
    In_Progress = 3,
    Completed = 4,
    Closed = 5 ,
    Catalogued = 6,
    LotNumbersAssigned = 7,
    DidNotRun = 8
};